import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex max-h-full w-[380px]',
    wrapper: 'max-h-[80vh] w-full overflow-auto bg-white px-10 pb-6',
    item: 'hover:bg-bg-page flex items-center justify-between px-4 py-3 select-none',
    itemLabel: 'flex items-center gap-2.5',
    itemCircle: 'size-3 rounded-full',
    itemCircleWrapper: 'flex size-6 min-w-6 items-center justify-center',
    group: 'group bg-bg-page -mx-10 mb-2 px-10 py-2',
    children: 'absolute top-0 left-full h-full w-full'
  },
  variants: {
    link: {
      true: {
        item: 'cursor-pointer'
      }
    },
    itemActive: {
      true: {
        item: 'bg-bg-page'
      }
    },
    itemGroup: {
      true: {
        item: 'hover:bg-white'
      }
    }
  },
  compoundVariants: [
    {
      itemGroup: true,
      itemActive: true,
      className: {
        item: 'bg-white'
      }
    }
  ]
});
